import React from 'react';
import styled from 'styled-components';
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  FloatButton,
  Tooltip as AntdTooltip,
  Card,
  Typography,
  Tabs,
  InputNumber,
  Upload,
  Collapse,
  Avatar,
  ColorPicker,
  Checkbox,
  DatePicker,
  Calendar,
  Tag,
  message,
  Progress
} from 'antd';
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  PlusCircleOutlined,
  PlusCircleFilled,
  CheckCircleOutlined,
  StopFilled,
  CloseCircleOutlined,
  RocketFilled,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  CaretRightOutlined,
  RightCircleFilled,
  CommentOutlined,
  CustomerServiceOutlined,
  SwapRightOutlined,
  InfoCircleFilled,
  EditFilled
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import Notify from 'src/components/meta/Notification';
import Highlighter from 'react-highlight-words';
import Resizer from 'react-image-file-resizer';
import payfastImg from 'src/static/Payfast-io-logo.png';
import CODImg from 'src/static/cod-icon.png';
import EFTImg from 'src/static/eft-icon.png';
import ShippingImg from 'src/static/shipping-icon.png';
import CardBackImg from 'src/static/card-back-hex-1.png';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip } from 'recharts';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer
} from 'recharts';
import { BarChart, Bar, Legend } from 'recharts';
import { connect } from 'react-redux';
import { getSidebarCollapsed, getUser } from 'src/redux/selectors';
import {
  criteriaWithHistory,
  scaleOfRecord,
  toPercent
} from 'src/constants/experienceCriteria';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const { Title } = Typography;
const { TextArea } = Input;
const { Column } = Table;
const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const { Option } = Select;

const StyledCard = styled(Card)`
  text-align: center;
  border-radius: 12px;
  font-size: 22px;
  font-weight: bold;
  color: white;
  height: 140px;
`;

const BlueCard = styled(StyledCard)`
  background: linear-gradient(to bottom, #4a90e2, #673ab7);
`;

const RedCard = styled(StyledCard)`
  background: linear-gradient(to top, rgb(119, 11, 16), rgb(255, 7, 36));
`;

const GreenCard = styled(BlueCard)`
  background: linear-gradient(to top, #1d976c, #93f9b9);
`;

const OrangeCard = styled(BlueCard)`
  background: linear-gradient(to top, #fc4a1a, #f7b733);
`;

const TotalLeaveCard = styled(BlueCard)`
  background: linear-gradient(to bottom, #4b79a1, #283e51);
`;

const LeaveBalanceCard = styled(BlueCard)`
  background: linear-gradient(to bottom, #c4e0e5, #4ca1af);
`;

const ScoreCard = styled(BlueCard)`
  background: linear-gradient(
    to top,
    rgba(40, 62, 81, 0.75),
    rgba(46, 191, 145, 0.75)
  );
`;

const StyledTable = styled(Table)``;
const Cards = styled(Card)`
  box-shadow: 0px 0px 20px 8px rgba(155, 155, 155, 0.2) !important;
`;
const CardActionPlan = styled(Card)`
  box-shadow: 0px 0px 20px 8px rgba(155, 155, 155, 0.2) !important;
  .ant-card-body {
    padding-top: 20px !important;

    border-radius: 0 0 8px 8px;
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: '';
  }
`;
const StyledInputNumber = styled(InputNumber)`
  font-weight: 500 !important;
  color: #525f7f !important;
  font-size: 15px !important;
  cursor: not-allowed;
  .ant-input-number-disabled .ant-input-number-input {
    font-weight: 500 !important;
    color: #525f7f !important;
    font-size: 15px !important;
    cursor: not-allowed;
  }
`;
const Selection = styled(Select)`
  .ant-select-selection {
    border: 1px solid #bdb2b2;
    height: 45px;
    font-size: 12px;
  }
  .ant-select-selection__placeholder {
    top: 21px;
  }
  .ant-select-selection__rendered {
    height: 44px;
  }
  .ant-select-selection-selected-value {
    position: relative;
    top: 6px;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;

function callback(key) {
  console.log(key);
}
const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}

function handleChange(value) {
  console.log(`selected ${value}`);
}

class Tailoring extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSiteId: '',
      loading: false,
      closed: false,
      rejectReason: '',
       siteSelected:
        this.props.user.access && this.props.user.access.length > 0
          ? String(this.props.user.access[0])
          : this.props.sites[0]
          ? String(this.props.sites[0]._id)
          : null,

      // ✅ NEW: inventory site used ONLY for cost table
      inventoryCostSiteId: null,
      editTailoring: undefined,
      size: 'large',
      flag: false,
      currentTab: 'All',
      selectedMonth: dayjs().format('MM'),
      selectedYear: dayjs().format('YYYY'),
      stockData: [],
      stockRequests: [],
      filteredTailoring: [], // Holds the filtered data
      selectedCategories: [],
      categoryStatusData: [],
      pageSize: 10000, // or any default page size you prefer
      filteredStock: [], // Holds the filtered data
      filteredCost: [], // Holds the filtered data
      filteredRooms: [] // Holds the filtered data
    };
  }

  componentDidMount = () => {
    this.setState({ loading: true });

    Promise.all([
      this.fetchAllStock(),
      this.fetchAllStockRequests(),
      this.fetchAllExperience(),
      this.fetchAllSpecial(),
      this.fetchAllTailoring(),
      this.fetchAllSites(),
      this.fetchAllSitesInventory(),
      this.fetchAllUsers()
    ])
      .then(() => {
        this.setState(
          {
            loading: false
          },
          () => {
            this.filterData(); // Apply filters after setting initial state
          }
        );

        window.addEventListener('resize', this.resizeEvent);

        if (window.cordova) {
          document.addEventListener('backbutton', this.handleBack);
        }
      })
      .catch(error => {
        console.error('Error during componentDidMount:', error);
        this.setState({ loading: false });
        Notify('error', 'Error', error.message || 'An error occurred');
      });
  };
  componentDidUpdate(prevProps) {
    // when sites list arrives/changes
    if (
      prevProps.sites !== this.props.sites &&
      (this.props.sites || []).length > 0
    ) {
      // if nothing selected yet, select the first site
      const siteSelected =
        this.state.siteSelected || String(this.props.sites[0]._id);

      // find mapping
      const selectedSite = (this.props.sites || []).find(
        s => String(s._id) === String(siteSelected)
      );
      const inventoryCostSiteId = selectedSite?.inventorySiteId
        ? String(selectedSite.inventorySiteId)
        : null;

      // only set once
      if (
        String(this.state.siteSelected || '') !== String(siteSelected) ||
        String(this.state.inventoryCostSiteId || '') !==
          String(inventoryCostSiteId || '')
      ) {
        this.setState({ siteSelected, inventoryCostSiteId }, async () => {
          // load requests ONLY if mapped inventory site exists
          if (inventoryCostSiteId) {
            await this.fetchAllStockRequests(1, 10000);
          }
          this.filterData();
        });
      }
    }
  }

  fetchAllStock = async (page = 1, pageSize = 10000) => {
    console.log('Fetching stock with:', {
      site: this.state.siteSelected,
      year: this.state.selectedYear,
      month: this.state.selectedMonth
    });

    try {
      this.setState({ loading: true });

      const response = await this.props.findAllStock(
        this.state.siteSelected,
        this.state.currentPage,
        this.state.pageSize,
        '', // search query
        this.state.selectedYear,
        this.state.selectedMonth
      );

      const { stock, total } = response.data;

      this.setState({
        stockData: stock,
        totalStock: total,
        stock,
        totalItems: total,
        currentPage: page,
        pageSize,
        loading: false
      });
    } catch (error) {
      console.error('fetchAllStock error:', error);
      this.setState({ loading: false });
      Notify('error', error.message);
    }
  };

  fetchAllStockRequests = async (page = 1, pageSize = 10000) => {
    try {
      this.setState({ loading: true });

      // use inventory site if selected, otherwise fall back to main site
      const accessForRequests = this.state.inventoryCostSiteId;
      if (!accessForRequests) return; // no mapped inventory site => don't fetch

      if (!accessForRequests) {
        this.setState({ loading: false });
        Notify('error', 'Please select a site first.');
        return;
      }

      // proper month date range
      const startDate = dayjs(
        `${this.state.selectedYear}-${this.state.selectedMonth}-01`
      ).format('YYYY-MM-DD');

      const endDate = dayjs(
        `${this.state.selectedYear}-${this.state.selectedMonth}-01`
      )
        .endOf('month')
        .format('YYYY-MM-DD');

      const response = await this.props.findAllStockRequests(
        String(accessForRequests),
        startDate,
        endDate,
        page,
        pageSize
      );

      const { stock, total } = response?.data || {};

      this.setState(
        {
          stockRequests: stock || [], // ✅ IMPORTANT: match filterData()
          totalStockRequests: total || 0,
          loading: false
        },
        () => {
          this.filterData(); // ✅ refresh Variable Cost table immediately
        }
      );

      return { stock: stock || [], total: total || 0 };
    } catch (error) {
      console.error('fetchAllStockRequests error:', error);
      this.setState({ loading: false });
      Notify('error', error?.message || 'Failed to fetch stock requests');
    }
  };

  fetchAllTailoring = () => {
    const { selectedYear, siteSelected, selectedMonth } = this.state;

    return this.props
      .findAllTailoring(siteSelected, selectedYear, selectedMonth)
      .catch(error => {
        throw new Error(`Error fetching tailoring: ${error}`);
      });
  };

  fetchAllSites = () => {
    return this.props.findAllSites().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };
  fetchAllSitesInventory = () => {
    return this.props.findAllSitesInventory().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };

  fetchAllUsers = () => {
    return this.props.findAllUsers().catch(error => {
      throw new Error(`Error fetching users: ${error}`);
    });
  };
  fetchAllExperience = () => {
    const { selectedYear, siteSelected, selectedMonth } = this.state;

    return this.props
      .findAllExperience(siteSelected, selectedYear, selectedMonth)
      .catch(error => {
        throw new Error(`Error fetching experience: ${error}`);
      });
  };

  fetchAllSpecial = () => {
    const { selectedYear, selectedMonth, siteSelected } = this.state;

    return this.props
      .findAllSpecial(siteSelected, selectedYear, selectedMonth)
      .catch(error => {
        throw new Error(`Error fetching special stock: ${error}`);
      });
  };

  getSiteById = (arr, id) =>
    (arr || []).find(s => String(s._id) === String(id));

  accessMatches = (itemAccess, siteId) => {
    if (!siteId) return true;

    const target = String(siteId);

    const arr = Array.isArray(itemAccess)
      ? itemAccess.map(String)
      : itemAccess
      ? [String(itemAccess)]
      : [];

    return arr.includes(target);
  };

  getFxNumber = v => {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  };

  formatMoney = (currency, amount) =>
    `${currency} ${(Number(amount) || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  normalizeCurrency = cur => {
    const c = String(cur || '').trim();
    if (!c) return '';
    const upper = c.toUpperCase();

    // aliases
    if (upper === 'TZS') return 'TZS'; // treat Tanzanian Shilling label as TZS
    return upper;
  };
  // converts amount in sourceSite currency -> targetSite currency
  // uses targetSite.exchange which (in your data) is "currency -> USD"
  convertToTargetCurrency = (amount, sourceSite, targetSite) => {
    const sourceCur = this.normalizeCurrency(sourceSite?.companyCurrency);
    const targetCur = this.normalizeCurrency(targetSite?.companyCurrency);
    const ex = targetSite?.exchange || {};
    const srcToUSD = Number(ex[sourceCur]);
    const tgtToUSD = Number(ex[targetCur]);
    const n = Number(amount) || 0;

    if (!sourceCur || !targetCur) {
      return { currency: targetCur || sourceCur || 'USD', value: n };
    }

    // same currency, no conversion
    if (sourceCur === targetCur) {
      return { currency: targetCur, value: n };
    }

    // If we don't have a source rate, cannot convert -> fallback to source currency
    if (!srcToUSD || srcToUSD <= 0) {
      return { currency: sourceCur, value: n };
    }

    // Convert source -> USD
    const usd = n * srcToUSD;

    // If target is USD, done
    if (targetCur === 'USD') {
      return { currency: 'USD', value: usd };
    }

    // Convert USD -> target (need target rate)
    if (!tgtToUSD || tgtToUSD <= 0) {
      // no target rate -> fallback to source currency
      return { currency: sourceCur, value: n };
    }

    return { currency: targetCur, value: usd / tgtToUSD };
  };

  handleBack = () => {
    if (this.state.addTailoringVisible) {
      this.setState({ addTailoringVisible: false });
    } else {
      this.props.history.goBack();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  tailoringForm;
  onAddTailoring = e => {
    this.setState({ addTailoringVisible: true, editTailoring: undefined });
  };

  handleAddTailoring = e => {
    e.preventDefault();
    this.tailoringForm.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const updatedLoggedDates = this.tailoringForm.state?.loggedDates || [];
        const currentLoggedDates = this.tailoringForm.state.loggedDates || [];

        // Merge and remove duplicates
        const mergedLoggedDates = [
          ...updatedLoggedDates,
          ...currentLoggedDates.filter(
            newEntry =>
              !updatedLoggedDates.some(
                existingEntry =>
                  existingEntry.date === newEntry.date &&
                  existingEntry.type === newEntry.type
              )
          )
        ];

        console.log('Final Merged Logged Dates:', mergedLoggedDates); // Debugging

        values.loggedDates = mergedLoggedDates; // Save updated dates
        values.mainHomeImage = this.tailoringForm.state.mainHomeImage;
        values.mainSpecialImage1 = this.tailoringForm.state.mainSpecialImage1;

        if (this.state.editTailoring) {
          values._id = this.state.editTailoring._id;
        }

        console.log('Final Data Being Sent to Backend:', values); // Debugging

        this.props
          .addTailoring(values)
          .then(() => {
            this.props.findAllTailoring().then(() => {
              Notify('success', 'Successfully saved tailoring');
              this.tailoringForm.props.form.resetFields();
              this.setState({
                loading: false,
                addTailoringVisible: false,
                editTailoring: undefined,
                loggedDates: [] // Reset loggedDates after saving
              });
            });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    });
  };
  handleSearchName = () => {
    if (this.state.siteSelected.length > 0) {
      // this.handleSelectFocus();
      this.setState({ loading: true }); // Set loading state to true before API call
      this.props
        .findAllTailoring(this.state.siteSelected)
        .then(response => {
          const { stock, total } = response.data; // Destructure total from response
          this.setState({
            loading: false
            // stock: stock, // Update stock with fetched data
            // totalStock: total, // Set totalStock with the total count from the API
            // currentPage: 1, // Reset to the first page when fetching new data
          });
        })
        .catch(e => {
          this.setState({ loading: false });
          Notify('error', e.message);
        });
    }
  };

  handleEditTailoring = e => {
    this.setState({ addTailoringVisible: true, editTailoring: e });
  };

  handleDeleteTailoring = e => {
    const id = e.currentTarget.getAttribute('data');
    var that = this;
    Modal.confirm({
      centered: true,
      content: (
        <div>
          <h4>Are you sure you want to delete this tailoring?</h4>
        </div>
      ),
      onOk() {
        that.setState({ loading: true });
        that.props
          .deleteTailoring(id)
          .then(() => {
            that.props
              .findAllTailoring()
              .then(() => {
                that.setState({ loading: false, currentTab: 'All' });
                // that.props.find140mm();
                // that.props.find171mm();
                Notify('success', 'Successfully deleted tailoring');
              })
              .catch(e => {
                that.setState({ loading: false });
                Notify('error', e);
              });
          })
          .catch(e => {
            that.setState({ loading: false });
            Notify('error', e);
          });
      },
      oncancel() {}
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });

  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };
  handleInventorySiteChange = siteId => {
    this.setState(
      { inventorySiteSelected: siteId, loading: true },
      async () => {
        try {
          // ✅ refetch requests for that inventory site
          await this.fetchAllStockRequests(1, 10000);

          // ✅ rebuild tables
          this.filterData();
        } catch (e) {
          console.error('handleInventorySiteChange error:', e);
          Notify('error', e.message || 'Failed to change inventory site');
        } finally {
          this.setState({ loading: false });
        }
      }
    );
  };

  changeTypeTab = key => {
    this.setState({ currentTab: key });
  };
  handleYearChange = date => {
    const selectedYear = date ? dayjs(date).format('YYYY') : null;

    this.setState({ selectedYear, loading: true }, async () => {
      try {
        await Promise.all([
          this.fetchAllStock(),
          this.fetchAllStockRequests(),
          this.fetchAllTailoring(),
          this.fetchAllExperience(),
          this.fetchAllSpecial()
        ]);
        this.filterData(); // ✅ Run after data is fetched
      } catch (error) {
        console.error('Error fetching data for selected year:', error);
      } finally {
        this.setState({ loading: false });
      }
    });
  };

  handleMonthChange = async date => {
    const selectedMonth = date ? dayjs(date).format('MM') : null;

    this.setState({ selectedMonth }, async () => {
      this.setState({ loading: true });
      try {
        await this.fetchAllStockRequests();
      } catch (err) {
        console.error('Error in fetchAllStockRequests:', err);
      }
      try {
        // Wrap each fetch to debug independently
        try {
          await this.fetchAllStock();
        } catch (err) {
          console.error('Error in fetchAllStock:', err);
        }

        try {
          await this.fetchAllTailoring();
        } catch (err) {
          console.error('Error in fetchAllTailoring:', err);
        }

        try {
          await this.fetchAllExperience();
        } catch (err) {
          console.error('Error in fetchAllExperience:', err);
        }

        try {
          await this.fetchAllSpecial();
        } catch (err) {
          console.error('Error in fetchAllSpecial:', err);
        }

        this.filterData();
      } catch (error) {
        console.error('Error in handleMonthChange:', error);
      } finally {
        this.setState({ loading: false });
      }
    });
  };
  handleSiteChange = siteId => {
    const selectedSite = (this.props.sites || []).find(
      s => String(s._id) === String(siteId)
    );

    const inventoryCostSiteId = selectedSite?.inventorySiteId
      ? String(selectedSite.inventorySiteId)
      : null; // ✅ no mapping => use original cost code

    this.setState(
      { siteSelected: siteId, inventoryCostSiteId, loading: true },
      async () => {
        try {
          await Promise.all([
            this.fetchAllStock(),
            this.fetchAllTailoring(),
            this.fetchAllExperience(),
            this.fetchAllSpecial(),

            // ✅ only fetch requests when we actually have a mapped inventory site
            inventoryCostSiteId
              ? this.fetchAllStockRequests()
              : Promise.resolve()
          ]);

          this.filterData();
        } catch (error) {
          console.error('Error fetching data for selected site:', error);
        } finally {
          this.setState({ loading: false });
        }
      }
    );
  };

  groupExperienceData = experienceData => {
    const { selectedYear, selectedMonth } = this.state;

    // Questions this site asks now, plus any it used to ask that still have
    // reviews, so changing them doesn't blank the chart's history.
    const site = (this.props.sites || []).find(
      s => String(s._id) === String(this.state.siteSelected)
    );
    const experienceCriteria = criteriaWithHistory(site, experienceData);

    // Filter data based on the selected year and month
    const filteredData = experienceData.filter(item => {
      const itemDate = dayjs(item.timestamp);
      const matchesYear = selectedYear
        ? itemDate.format('YYYY') === selectedYear
        : true;
      const matchesMonth = selectedMonth
        ? itemDate.format('MM') === selectedMonth
        : true;

      return matchesYear && matchesMonth;
    });

    // Group and aggregate the filtered data
    const groupedData = filteredData.reduce((acc, item) => {
      const monthKey = dayjs(item.timestamp).format('YYYY-MM'); // Ensure correct sorting format

      if (!acc[monthKey]) {
        acc[monthKey] = {
          month: monthKey,
          totalAvgScore: 0,
          lowScoreCount: 0, // Count of low scores (bottom half of the scale)
          totalReviews: 0, // Total individual review scores
          numberOfCards: 0,
          records: [],
          criteria: experienceCriteria
        };
        experienceCriteria.forEach(c => {
          acc[monthKey][`${c.key}Sum`] = 0;
          acc[monthKey][`${c.key}Count`] = 0;
        });
      }

      // Percentages, not raw stars: a site that moved from 4 to 5 stars would
      // otherwise have its history rescored. Each review is measured against
      // the scale it was captured on.
      const scale = scaleOfRecord(item);
      experienceCriteria.forEach(c => {
        const percent = toPercent(item[c.key], scale);
        if (percent === null) return;

        acc[monthKey][`${c.key}Sum`] += percent;
        acc[monthKey][`${c.key}Count`] += 1;
        if (percent < 50) acc[monthKey].lowScoreCount++;
        acc[monthKey].totalAvgScore += percent;
        acc[monthKey].totalReviews++;
      });

      acc[monthKey].numberOfCards++;
      acc[monthKey].records.push(item);

      return acc;
    }, {});

    // Convert grouped data into an array and compute averages
    const groupedArray = Object.values(groupedData)
      .map(month => {
        const avg = (sum, count) => (count > 0 ? sum / count : 0);
        const result = { ...month };
        experienceCriteria.forEach(c => {
          // Percent, 0-100.
          result[`${c.key}Avg`] = avg(
            month[`${c.key}Sum`],
            month[`${c.key}Count`]
          );
        });

        return {
          ...result,
          totalAvgScore:
            month.totalReviews > 0
              ? (month.totalAvgScore / month.totalReviews).toFixed(1) // ✅ Proper average
              : 'N/A',

          // ✅ Correctly calculate low score percentage
          lowScorePercentage:
            month.totalReviews > 0
              ? Math.round((month.lowScoreCount / month.totalReviews) * 100)
              : 0
        };
      })
      .sort((a, b) =>
        dayjs(b.month, 'YYYY-MM').diff(dayjs(a.month, 'YYYY-MM'))
      ); // ✅ Sort by latest month first

    // If only the year is selected, return only the latest month
    if (selectedYear && !selectedMonth && groupedArray.length > 0) {
      return [groupedArray[0]]; // Return only the latest month
    }

    return groupedArray;
  };

  filterData = () => {
    const {
      selectedYear,
      selectedMonth,
      siteSelected,
      stockData,
      stockRequests,
      inventorySiteSelected
    } = this.state;

    const { tailoring, experience, special } = this.props; // Assuming tailoring and stockData contain the raw data
    const currentMonth = dayjs().format('YYYY-MM'); // Get the current month in YYYY-MM format

    console.log('Special Data:', special);
    console.log(
      'Selected Year:',
      selectedYear,
      'Selected Month:',
      selectedMonth
    );

    // Helper function to check year and month match
    const matchesYearAndMonth = date => {
      const itemYear = dayjs(date).format('YYYY');
      const itemMonth = dayjs(date).format('MM');

      return (
        (!selectedYear || itemYear === selectedYear) &&
        (!selectedMonth || itemMonth === selectedMonth)
      );
    };

    // Filter tailoring data
    const filteredTailoring = tailoring.filter(item => {
      const matchesSite = siteSelected ? item.access === siteSelected : true;
      const matchesDate =
        selectedYear || selectedMonth
          ? item.loggedDates.some(log => matchesYearAndMonth(log.date))
          : true;

      return matchesSite && matchesDate;
    });

    // Filter stock data
    const filteredStock = stockData.filter(
      item =>
        item.saleDate &&
        matchesYearAndMonth(item.saleDate) &&
        (siteSelected ? item.access === siteSelected : true)
    );

    const filteredRooms = stockData.filter(
      item =>
        item.roomsDate &&
        matchesYearAndMonth(item.roomsDate) &&
        (siteSelected ? item.access === siteSelected : true)
    );
    const costSite = inventorySiteSelected || siteSelected;
    const filteredRoomsForCost = (stockRequests || []).filter(
      item =>
        item.requestDate &&
        matchesYearAndMonth(item.requestDate) &&
        this.accessMatches(item.access, costSite)
    );
    const bednightsMTDForCost = filteredRoomsForCost.reduce((sum, item) => {
      const roomsPAX = Array.isArray(item.roomsPAX)
        ? item.roomsPAX.reduce((total, val) => total + (Number(val) || 0), 0)
        : Number(item.roomsPAX) || 0;

      return sum + roomsPAX;
    }, 0);
    const bednightsMTD = filteredRooms.reduce((sum, item) => {
      const roomsPAX = Array.isArray(item.roomsPAX)
        ? item.roomsPAX.reduce((total, val) => total + (Number(val) || 0), 0)
        : Number(item.roomsPAX) || 0;

      return sum + roomsPAX;
    }, 0);

    const staffOnSiteMTD = filteredRooms.reduce((sum, item) => {
      return sum + (Number(item.staffOnSite) || 0);
    }, 0);

    const guideMealsMTD = filteredRooms.reduce((sum, item) => {
      return sum + (Number(item.guideMeals) || 0);
    }, 0);

    // Complimentary is tracked as a cost, mirroring Variable Cost: it gets its
    // own total and never feeds into totalIncome.
    const filteredComp = stockData.filter(
      item =>
        item.compDate &&
        matchesYearAndMonth(item.compDate) &&
        (siteSelected ? item.access === siteSelected : true)
    );

    const compMTD = filteredComp.reduce((sum, item) => {
      const value = Array.isArray(item.compValue)
        ? item.compValue.reduce((total, val) => total + (Number(val) || 0), 0)
        : Number(item.compValue) || 0;

      return sum + value;
    }, 0);

    const compCountMTD = filteredComp.reduce((sum, item) => {
      return sum + (Array.isArray(item.compValue) ? item.compValue.length : 0);
    }, 0);

    // Per-category breakdown, same shape as the Variable Cost grouping.
    // No currency conversion here: comp values are captured on the selected
    // site's own stock record, so they are already in its currency. Variable
    // Cost converts because inventory costs can originate at another site.
    const groupedComp = Object.values(
      filteredComp.reduce((acc, item) => {
        const categories = Array.isArray(item.compCategory)
          ? item.compCategory
          : [];
        const values = Array.isArray(item.compValue) ? item.compValue : [];

        values.forEach((val, index) => {
          const key = categories[index] || 'Uncategorised';
          if (!acc[key]) {
            acc[key] = { compCategory: key, totalComp: 0, count: 0 };
          }
          acc[key].totalComp += Number(val) || 0;
          acc[key].count += 1;
        });

        return acc;
      }, {})
    ).map(row => ({
      ...row,
      MTD_Comp: bednightsMTD > 0 ? row.totalComp / bednightsMTD : 0
    }));

    const refundsMTD = filteredStock.reduce((sum, item) => {
      const saleRefund = Array.isArray(item.saleRefund)
        ? item.saleRefund.reduce((total, val) => total + (Number(val) || 0), 0)
        : Number(item.saleRefund) || 0;

      return sum - saleRefund; // Keep it negative
    }, 0);

    const totalOffDays = filteredTailoring.reduce((sum, record) => {
      return (
        sum + record.loggedDates.filter(log => log.type === 'Offdays').length
      );
    }, 0);

    const totalLeaveDays = filteredTailoring.reduce((sum, record) => {
      return (
        sum + record.loggedDates.filter(log => log.type === 'Leave Days').length
      );
    }, 0);

    const totalLeaveBalance = filteredTailoring.reduce((sum, record) => {
      const leaveUsed = record.loggedDates.filter(
        log => log.type === 'Leave Days'
      ).length;
      return sum + (28 - leaveUsed); // Assuming 28 days annual leave
    }, 0);

    const groupedExtraSales = filteredStock
      .filter(item => item.saleCategory) // Ensure saleCategory exists
      .reduce((acc, item) => {
        const saleDateMonth = dayjs(item.saleDate).format('MM'); // Extract month

        console.log('Sale Date:', item.saleDate); // Debugging
        console.log('Formatted Sale Date Month:', saleDateMonth); // Debugging
        console.log('Current Month:', currentMonth); // Debugging

        const categories = item.saleCategory || []; // Get categories array
        const extraSalesArray = item.extraSales || []; // Get extraSales array
        const saleRefundArray = item.saleRefund || []; // Get saleRefund array

        const roomsPAX = bednightsMTD || 0; // ✅ Correctly fetching roomsPAX

        if (categories.length !== extraSalesArray.length) {
          console.warn(
            'Mismatch between saleCategory and extraSales length in item:',
            item
          );
        }

        categories.forEach((category, index) => {
          const extraSales = Number(extraSalesArray[index]) || 0; // ✅ Get the correct extraSales per category
          const saleRefund = Number(saleRefundArray[index]) || 0; // ✅ Get the correct saleRefund per category

          if (!acc[category]) {
            acc[category] = {
              saleCategory: category,
              totalIncome: 0, // ✅ Now includes refunds deduction
              totalRefunds: 0,
              totalIncomePerBednight: 0,
              monthToDateIncome: 0, // ✅ Now includes refunds deduction
              monthToDateRefunds: 0,
              MTD_Sale: 0
            };
          }

          // ✅ Subtract refunds from total income
          // acc[category].totalIncome += extraSales - saleRefund;
          acc[category].totalIncome += extraSales;
          acc[category].totalRefunds += saleRefund;

          // ✅ Calculate perBednight correctly per category
          // acc[category].totalIncomePerBednight += roomsPAX > 0 ? (extraSales - saleRefund) / roomsPAX : 0;
          acc[category].totalIncomePerBednight +=
            roomsPAX > 0 ? extraSales / roomsPAX : 0;

          // ✅ Month-to-Date calculations
          if (saleDateMonth === this.state.selectedMonth) {
            acc[category].monthToDateIncome += extraSales; // ✅ Subtract refunds
            // acc[category].monthToDateIncome += extraSales - saleRefund; // ✅ Subtract refunds
            acc[category].monthToDateRefunds += saleRefund;
            // acc[category].MTD_Sale += roomsPAX > 0 ? (extraSales - saleRefund) / roomsPAX : 0; // ✅ Adjusted per bednight calculation
            acc[category].MTD_Sale += roomsPAX > 0 ? extraSales / roomsPAX : 0; // ✅ Adjusted per bednight calculation
          }
        });

        return acc;
      }, {});

    // ✅ Convert grouped object into an array for rendering
    const formattedExtraSales = Object.values(groupedExtraSales);

    const { inventoryCostSiteId } = this.state;

    // --- COST SOURCE SWITCH ---
    // If mapped inventory site exists => use stockRequests (requestDate)
    // Else => use original stockData costDate
    let filteredCost;
    let groupedVarCost;

    if (inventoryCostSiteId) {
      // NEW (inventory-mapped) cost flow: from requests
      filteredCost = (stockRequests || []).filter(
        item =>
          item.requestDate &&
          matchesYearAndMonth(item.requestDate) &&
          this.accessMatches(item.access, inventoryCostSiteId)
      );

      groupedVarCost = Object.values(
        (filteredCost || []).reduce((acc, item) => {
          const key = item.masterAllocation || 'Uncategorized';
          const totalCost =
            Number(item.totalCosts) || Number(item.costPerUnit) || 0;

          const requestMonth = dayjs(item.requestDate).format('MM');
          // Staff Canteen Cost is divided by staff on site, not bed nights
          const isStaffCanteen = item.masterAllocation === 'Staff Canteen Cost';
          const divisor = isStaffCanteen
            ? staffOnSiteMTD || 0
            : bednightsMTD || 0;
          const perBednight = divisor > 0 ? totalCost / divisor : 0;

          if (!acc[key]) {
            acc[key] = { costCategory: key, totalCost: 0, MTD_Cost: 0 };
          }

          acc[key].totalCost += totalCost;
          if (requestMonth === this.state.selectedMonth) {
            acc[key].MTD_Cost += perBednight;
          }

          return acc;
        }, {})
      );
    } else {
      // ORIGINAL cost flow: from stockData.costDate
      filteredCost = stockData.filter(
        item =>
          item.costDate &&
          matchesYearAndMonth(item.costDate) &&
          (siteSelected ? item.access === siteSelected : true)
      );

      groupedVarCost = Object.values(
        filteredCost
          .filter(item => Array.isArray(item.costCategory))
          .reduce((acc, item) => {
            const costDateMonth = dayjs(item.costDate).format('MM');

            item.costCategory.forEach((category, index) => {
              const totalCost = Array.isArray(item.costPrice)
                ? Number(item.costPrice[index]) || 0
                : Number(item.costPrice) || 0;

              // Staff Food cost is per staff on site; all other categories use bed nights
              const isStaffFood = category === 'Staff Food';
              const divisor = isStaffFood
                ? staffOnSiteMTD || 0
                : bednightsMTD || 0;
              const perBednight = divisor > 0 ? totalCost / divisor : 0;

              if (!acc[category]) {
                acc[category] = {
                  costCategory: category,
                  totalCost: 0,
                  totalCostPerPerson: 0,
                  MTD_Cost: 0
                };
              }

              acc[category].totalCost += totalCost;

              if (costDateMonth === this.state.selectedMonth) {
                acc[category].MTD_Cost += perBednight;
              }
            });

            return acc;
          }, {})
      );
    }

    const filteredExperience = experience.filter(item => {
      const matchesDate = matchesYearAndMonth(item.timestamp);
      const matchesSite = siteSelected ? item.access === siteSelected : true;

      return matchesSite && matchesDate;
    });

    const groupedExperienceData = this.groupExperienceData(filteredExperience);

    const filteredSpecial = special.filter(item => {
      const matchesDate = matchesYearAndMonth(item.actionDeadline);
      const matchesSite = siteSelected ? item.access === siteSelected : true;

      return matchesSite && matchesDate;
    });

    const departmentCompletion = filteredSpecial.reduce((acc, item) => {
      const department = item.actionDepartment || 'Uncategorized';

      if (!acc[department]) {
        acc[department] = { total: 0, completed: 0 };
      }

      acc[department].total += 1;
      if (item.actionStatus === 'Completed') {
        acc[department].completed += 1;
      }

      return acc;
    }, {});

    // after your existing departmentCompletion reducer:
    const statusCounts = filteredSpecial.reduce((acc, item) => {
      const status = item.actionStatus || 'Uncategorized';
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});

    const totalItems = filteredSpecial.length;

    // 2) now separately filter *only* for the category card:
    const catFiltered = filteredSpecial.filter(item => {
      const cat = item.actionDepartment || 'Uncategorized';
      return (
        this.state.selectedCategories.length === 0 ||
        this.state.selectedCategories.includes(cat)
      );
    });

    // 3) build your catMap from catFiltered:
    const catMap = catFiltered.reduce((acc, item) => {
      const cat = item.actionDepartment || 'Uncategorized';
      const status = item.actionStatus || 'Uncategorized';
      if (!acc[cat]) acc[cat] = { total: 0, statusCounts: {} };
      acc[cat].total++;
      acc[cat].statusCounts[status] = (acc[cat].statusCounts[status] || 0) + 1;
      return acc;
    }, {});

    // 4) turn that into categoryStatusData exactly as before:
    const categoryStatusData = Object.entries(catMap).map(
      ([category, { total, statusCounts }]) => ({
        category,
        statuses: Object.entries(statusCounts).map(([status, count]) => ({
          status,
          percentage: total > 0 ? Math.round((count / total) * 100) : 0
        }))
      })
    );

    // Update state with all filtered and aggregated data
    this.setState({
      filteredTailoring,
      categoryStatusData,
      groupedExperienceData,
      filteredStock,
      filteredCost,
      filteredRooms,
      bednightsMTD,
      staffOnSiteMTD,
      guideMealsMTD,
      compMTD,
      compCountMTD,
      filteredComp,
      groupedComp,
      totalLeaveDays,
      totalOffDays,
      totalLeaveBalance,
      refundsMTD,
      filteredExtraSales: Object.values(groupedExtraSales),
      filteredVarCost: Object.values(groupedVarCost)
    });
  };

  render() {
    let descriptions = this.props.tailoring.map(tailoring => {
      return { value: tailoring.description };
    });
    const { size, groupedExperienceData, categoryStatusData } = this.state;
    const { tailoring, stock } = this.props;
    let currentTailoring;
    if (this.state.currentTab === 'All') {
      currentTailoring = tailoring;
    } else {
      currentTailoring = tailoring.filter(
        tailoring => tailoring.size === this.state.currentTab
      );
    }

    const CategoryStatusCard = ({
      data,
      categories,
      selectedCategories,
      onCategoryChange
    }) => (
      <CardActionPlan
        title="Action Plan"
        // this is where we inject the Select into the card header:
        extra={
          <Select
            mode="multiple"
            placeholder="Filter by Category"
            value={selectedCategories}
            onChange={onCategoryChange}
            style={{ width: 170 }}
          >
            {categories.map(cat => (
              <Option key={cat} value={cat}>
                {cat}
              </Option>
            ))}
          </Select>
        }
        bordered={false}
        style={{
          backgroundImage: `url(${CardBackImg})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          width: 400,
          overflow: 'hidden',
          overflowY: 'scroll',
          marginTop: '2.5em',
          height: '405px'
        }}
      >
        {data.map(({ category, statuses }) => (
          <div key={category} style={{ marginBottom: '1.5em' }}>
            <h4 style={{ marginBottom: '0.5em', marginTop: '0em' }}>
              {category}
            </h4>
            {statuses.map(({ status, percentage }) => (
              <div key={status} style={{ marginBottom: '0.3em' }}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span>{status}</span>
                  <span>{percentage}%</span>
                </div>
                <Progress
                  showInfo={false}
                  percent={percentage}
                  status="active"
                  strokeColor={
                    percentage >= 80
                      ? '#51D375'
                      : percentage >= 50
                      ? 'orange'
                      : 'red'
                  }
                />
              </div>
            ))}
          </div>
        ))}
      </CardActionPlan>
    );

    // const getColor = (avg) => {
    //   if (avg >= 80) return "#51d375"; // Green for 80%-100%
    //   if (avg >= 40) return "#FFAD50"; // Orange for 40%-79%
    //   return "#E6242A"; // Red for 0%-39%
    // };

    const ExperienceBarChart = ({ groupedExperienceData }) => {
      // The chart follows whatever questions the site asks. groupExperienceData
      // stamps the criteria it used onto each month, so read them from there.
      const barOptions = (
        (groupedExperienceData &&
          groupedExperienceData[0] &&
          groupedExperienceData[0].criteria) ||
        []
      ).map(c => ({
        key: `${c.key}Avg`,
        label: c.retired ? `${c.label} (retired)` : c.label
      }));

      // Four bars is about all the chart reads well with.
      const [visibleBars, setVisibleBars] = React.useState(() =>
        barOptions.slice(0, 4).map(o => o.key)
      );

      // Return a fallback if no data is available
      if (!groupedExperienceData || groupedExperienceData.length === 0) {
        return (
          <Cards
            title="Guest Experience"
            style={{ marginTop: '2.5em', height: '390px', width: '100%' }}
          >
            No data available to display.
          </Cards>
        );
      }

      return (
        <Cards
          title="Guest Experience"
          style={{
            backgroundImage: `url(${CardBackImg})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <Select
            size="large"
            mode="multiple"
            value={visibleBars}
            onChange={selectedBars => setVisibleBars(selectedBars)}
            style={{ width: '100%', marginBottom: 25, marginTop: -16 }}
            placeholder="Select bars to display"
          >
            {barOptions.map(option => (
              <Option key={option.key} value={option.key}>
                {option.label}
              </Option>
            ))}
          </Select>

          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={groupedExperienceData.map(item => {
                const normalizedItem = {};
                for (let key in item) {
                  normalizedItem[key] =
                    typeof item[key] === 'number'
                      ? item[key].toFixed(1) // Already a percentage
                      : item[key];
                }
                return normalizedItem;
              })}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis
                tickFormatter={value => `${value}%`} // Add percentage symbol
              />
              <RechartsTooltip
                formatter={value =>
                  value ? `${parseFloat(value).toFixed(1)}%` : value
                }
              />
              <Legend />

              {/* Render bars dynamically based on visibility */}
              {/* {barOptions.map((option) =>
                visibleBars.includes(option.key) ? (
                  <Bar
                    key={option.key}
                    dataKey={option.key}
                    fill={getColor(
                      groupedExperienceData.reduce(
                        (sum, item) =>
                          sum + (item[option.key] || 0),
                        0
                      ) / groupedExperienceData.length
                    )}
                    name={option.label}
                  />
                ) : null
              )} */}
              <defs>
                {/* Green */}
                <linearGradient id="greenGradient" x1="0" x2="0" y1="1" y2="0">
                  <stop offset="0%" stopColor="#1d976c" />
                  <stop offset="100%" stopColor="#93f9b9" />
                </linearGradient>

                {/* Orange */}
                <linearGradient id="orangeGradient" x1="0" x2="0" y1="1" y2="0">
                  <stop offset="0%" stopColor="#fc4a1a" />
                  <stop offset="100%" stopColor="#f7b733" />
                </linearGradient>

                {/* Red */}
                <linearGradient id="redGradient" x1="0" x2="0" y1="1" y2="0">
                  <stop offset="0%" stopColor="rgb(119, 11, 16)" />
                  <stop offset="100%" stopColor="rgb(255, 7, 36)" />
                </linearGradient>
              </defs>
              {barOptions.map(option => {
                const avg =
                  groupedExperienceData.reduce(
                    (sum, item) => sum + (item[option.key] || 0),
                    0
                  ) / groupedExperienceData.length;

                // Determine which gradient to use
                let fillColor = '#ed213a'; // Default red
                if (avg >= 80) fillColor = 'url(#greenGradient)';
                else if (avg >= 40) fillColor = 'url(#orangeGradient)';
                else fillColor = 'url(#redGradient)';

                return visibleBars.includes(option.key) ? (
                  <Bar
                    key={option.key}
                    dataKey={option.key}
                    fill={fillColor}
                    name={option.label}
                  />
                ) : null;
              })}
            </BarChart>
          </ResponsiveContainer>
        </Cards>
      );
    };

    const aggregateAverageRoomRate = (filteredStock, filteredRooms) => {
      if (!Array.isArray(filteredStock) || filteredStock.length === 0) {
        return []; // Return empty array if no data is available
      }
      const bednightsMTD = filteredRooms.reduce((sum, item) => {
        const roomsPAX = Array.isArray(item.roomsPAX)
          ? item.roomsPAX.reduce((total, val) => total + (Number(val) || 0), 0)
          : Number(item.roomsPAX) || 0;

        return sum + roomsPAX;
      }, 0);
      const groupedData = filteredStock.reduce((acc, item) => {
        const dateKey = dayjs(item.saleDate).format('DD-MM-YYYY'); // Group by sale date

        if (!acc[dateKey]) {
          acc[dateKey] = { totalIncome: 0, totalBednights: 0, occupancy: null };
        }

        // ✅ **Income Calculation**
        const extraSales = Array.isArray(item.extraSales)
          ? item.extraSales.reduce((sum, val) => sum + (Number(val) || 0), 0)
          : Number(item.extraSales) || 0;
        const saleCash = Array.isArray(item.saleCash)
          ? item.saleCash.reduce((sum, value) => sum + (value || 0), 0)
          : item.saleCash || 0;
        const saleCard = Array.isArray(item.saleCard)
          ? item.saleCard.reduce((sum, value) => sum + (value || 0), 0)
          : item.saleCard || 0;
        const saleRefund = Array.isArray(item.saleRefund)
          ? item.saleRefund.reduce((sum, value) => sum + (value || 0), 0)
          : item.saleRefund || 0;
        const roomsPAX = Array.isArray(item.roomsPAX)
          ? item.roomsPAX.reduce((sum, value) => sum + (value || 0), 0)
          : item.roomsPAX || 0;

        acc[dateKey].totalIncome += extraSales; // ✅ Total Income
        acc[dateKey].totalBednights += roomsPAX; // ✅ Total Bednights

        return acc;
      }, {});

      // ✅ **Now Pull Occupancy Data from `filteredRooms`**
      filteredRooms.forEach(item => {
        const roomsDateKey = dayjs(item.roomsDate).format('DD-MM-YYYY');

        if (!groupedData[roomsDateKey]) {
          groupedData[roomsDateKey] = {
            totalIncome: 0,
            totalBednights: 0,
            occupancy: 0
          }; // Ensure object exists
        }

        groupedData[roomsDateKey].occupancy = item.roomOccupancy || 0; // ✅ Directly store occupancy
      });

      // ✅ **Convert to array & Sort**
      return Object.entries(groupedData)
        .map(([date, data]) => ({
          date,
          avgRate: bednightsMTD > 0 ? data.totalIncome / bednightsMTD : 0, // ✅ Room Rate
          occupancy: data.occupancy // ✅ Directly from `filteredRooms`
        }))
        .sort(
          (a, b) => dayjs(a.date, 'DD-MM-YYYY') - dayjs(b.date, 'DD-MM-YYYY')
        ); // Sort by date
    };
    const AverageRoomRateChart = ({
      filteredStock = [],
      filteredRooms = [],
      selectedYear,
      selectedMonth
    }) => {
      const chartData = aggregateAverageRoomRate(filteredStock, filteredRooms);
      const monthYearLabel = dayjs(
        `${selectedYear}-${selectedMonth}-01`
      ).format('MMMM YYYY');

      return (
        <Cards
          title={`Extra Sales vs Occupancy – ${monthYearLabel}`}
          style={{
            backgroundImage: `url(${CardBackImg})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            marginTop: '0.5em'
          }}
        >
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="date"
                tickFormatter={tick =>
                  dayjs(tick, 'DD-MM-YYYY').format('DD MMM')
                }
              />
              <YAxis
                yAxisId="left"
                label={{
                  value: 'Avg Rate',
                  angle: -90,
                  position: 'insideLeft'
                }}
              />
              <YAxis
                yAxisId="right"
                orientation="right"
                label={{
                  value: 'Occupancy %',
                  angle: -90,
                  position: 'insideRight'
                }}
              />
              <RechartsTooltip
                formatter={value =>
                  value.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })
                }
              />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="avgRate"
                stroke="#51D375"
                activeDot={{ r: 8 }}
                name="Extra Sales"
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="occupancy"
                stroke="#FF5733"
                activeDot={{ r: 8 }}
                name="Occupancy %"
              />
            </LineChart>
          </ResponsiveContainer>
        </Cards>
      );
    };

    const aggregateSingleMonthTotals = (
      stockData,
      roomData,
      selectedYear,
      selectedMonth
    ) => {
      const filteredStock = stockData.filter(item => {
        const date = dayjs(item.saleDate);
        return (
          item.saleDate &&
          date.format('YYYY') === selectedYear &&
          date.format('MM') === selectedMonth
        );
      });

      const filteredRooms = roomData.filter(item => {
        const date = dayjs(item.roomsDate);
        return (
          item.roomsDate &&
          date.format('YYYY') === selectedYear &&
          date.format('MM') === selectedMonth
        );
      });

      // Calculate total extra sales
      const totalExtraSales = filteredStock.reduce((sum, item) => {
        const extraSales = Array.isArray(item.extraSales)
          ? item.extraSales.reduce(
              (total, val) => total + (Number(val) || 0),
              0
            )
          : Number(item.extraSales) || 0;
        return sum + extraSales;
      }, 0);

      // Calculate average occupancy
      const occupancyTotal = filteredRooms.reduce((sum, item) => {
        return sum + (Number(item.roomOccupancy) || 0);
      }, 0);

      const occupancyCount = filteredRooms.length;
      const avgOccupancy =
        occupancyCount > 0 ? occupancyTotal / occupancyCount : 0;

      const monthLabel = dayjs(`${selectedYear}-${selectedMonth}-01`).format(
        'MMMM'
      );

      return [
        {
          month: monthLabel,
          totalExtraSales,
          avgOccupancy
        }
      ];
    };

    const SingleMonthChart = ({
      stockData,
      roomData,
      selectedYear,
      selectedMonth
    }) => {
      const data = aggregateSingleMonthTotals(
        stockData,
        roomData,
        selectedYear,
        selectedMonth
      );

      return (
        <Cards
          title={`Extra Sales vs Occupancy – ${data[0]?.month} ${selectedYear}`}
          style={{
            backgroundImage: `url(${CardBackImg})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            marginTop: '0.5em'
          }}
        >
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data}>
              <defs>
                {/* Green Gradient for Extra Sales */}
                <linearGradient id="greenGradient" x1="0" x2="0" y1="1" y2="0">
                  <stop offset="0%" stopColor="#1d976c" />
                  <stop offset="100%" stopColor="#93f9b9" />
                </linearGradient>

                {/* Orange Gradient for Occupancy */}
                <linearGradient id="orangeGradient" x1="0" x2="0" y1="1" y2="0">
                  <stop offset="0%" stopColor="#fc4a1a" />
                  <stop offset="100%" stopColor="#f7b733" />
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis
                yAxisId="left"
                label={{
                  value: 'Extra Sales',
                  angle: -90,
                  position: 'insideLeft'
                }}
                // tickFormatter={(value) => `R${value}`}
              />
              <YAxis
                yAxisId="right"
                orientation="right"
                label={{
                  value: 'Occupancy %',
                  angle: -90,
                  position: 'insideRight'
                }}
              />
              <RechartsTooltip
                formatter={(value, name) => {
                  const isOccupancy = name === 'Occupancy %';
                  return [
                    value.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }),
                    isOccupancy ? 'Occupancy %' : 'Extra Sales'
                  ];
                }}
              />
              <Bar
                yAxisId="left"
                dataKey="totalExtraSales"
                fill="url(#greenGradient)"
                name="Extra Sales"
                barSize={100}
              />
              <Bar
                yAxisId="right"
                dataKey="avgOccupancy"
                fill="url(#orangeGradient)"
                name="Occupancy %"
                barSize={100}
              />
            </BarChart>
          </ResponsiveContainer>
        </Cards>
      );
    };

    const ChartComponent = ({ filteredTailoring }) => {
      // Aggregate the data
      const totalOffDays = filteredTailoring.reduce((sum, record) => {
        return (
          sum + record.loggedDates.filter(log => log.type === 'Offdays').length
        );
      }, 0);

      const totalLeaveDays = filteredTailoring.reduce((sum, record) => {
        return (
          sum +
          record.loggedDates.filter(log => log.type === 'Leave Days').length
        );
      }, 0);

      const totalLeaveBalance = filteredTailoring.reduce((sum, record) => {
        const leaveUsed = record.loggedDates.filter(
          log => log.type === 'Leave Days'
        ).length;
        return sum + (28 - leaveUsed); // Assuming 28 days annual leave
      }, 0);

      // Prepare the chart data
      const chartData = [
        { name: 'Off Days', value: totalOffDays },
        { name: 'Leave Days', value: totalLeaveDays },
        { name: 'Leave Balance', value: totalLeaveBalance }
      ];

      return (
        <Cards title="Off and Leave Liability" style={{ marginTop: '2.5em' }}>
          <PieChart width={400} height={400}>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={150}
              fill="#8884d8"
              label
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={['#FFBB28', '#00C49F', '#80CE90', '#FF8042'][index % 4]} // Dynamic colors
                />
              ))}
            </Pie>
            <RechartsTooltip />
          </PieChart>
        </Cards>
      );
    };
    const companyCurrency =
      this.props.sites.find(site => site._id === this.state.siteSelected)
        ?.companyCurrency || 'Ksh';
    const userAccess = this.props.user?.access || []; // array of site _id's
    const accessibleSites = this.props.sites.filter(site =>
      userAccess.includes(site._id)
    );
    const selectedSite = this.props.sites.find(
      site => site._id === this.state.siteSelected
    );
    const props = this.props.collapsed;
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        <img
          style={{
            height: props ? '8em' : '13em',
            width: props ? '9.8em' : '16.1em',
            transform: props ? 'scale(0.6)' : 'scale(0.65)',
            position: 'fixed',
            left: props ? '-1.8em' : '0em',
            top: props ? '-1em' : '-1.8em',
            transition: '0.2s',
            objectFit: 'contain'
          }}
          src={
            selectedSite && selectedSite.mainCatImage
              ? selectedSite.mainCatImage.includes('data')
                ? selectedSite.mainCatImage
                : process.env.REACT_APP_GLOBAL_SERVER +
                  'sproutmanagement/api/images/' +
                  selectedSite.mainCatImage
              : null
          }
          // alt="Site"
        />
        <Spin spinning={this.state.loading}>
          <Row gutter={24} style={{ marginTop: '1em' }}>
            {' '}
            <Col span={8}>
              <h1
                style={{
                  marginBottom: '0em',
                  fontSize: '22px',
                  fontWeight: 800,
                  fontFamily: 'Nunito',
                  marginTop: '0.3em'
                }}
              >
                Dashboard Reports
              </h1>
            </Col>
            <Col span={16}>
              <DatePicker
                value={
                  this.state.selectedMonth
                    ? dayjs(this.state.selectedMonth)
                    : null
                }
                picker="month" // Month picker
                size="large"
                placeholder="Select Month"
                format="MMM"
                onChange={this.handleMonthChange} // Month change handler
                allowClear={false}
                style={{
                  width: '200px',
                  marginRight: '1em',
                  float: 'right'
                }}
              />
              <DatePicker
                value={
                  this.state.selectedYear
                    ? dayjs(this.state.selectedYear)
                    : null
                }
                picker="year" // Year picker
                size="large"
                placeholder="Select Year"
                format="YYYY"
                onChange={this.handleYearChange} // Year change handler
                allowClear={false}
                style={{
                  marginRight: '1em',
                  float: 'right',
                  width: '200px'
                }}
              />
              <Select
                size="large"
                value={this.state.siteSelected}
                showSearch
                onChange={this.handleSiteChange}
                style={{
                  marginRight: '1.2em',
                  width: '12em',
                  float: 'right'
                }}
                placeholder="Select Company"
                optionFilterProp="children"
              >
                {accessibleSites.map(site => (
                  <Select.Option key={site._id} value={site._id}>
                    {site.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col span={24} style={{ marginTop: '1em' }}>
          {/* Summary cards, four across */}
              <Row gutter={[12, 12]}>
                <Col span={6}>
                  <GreenCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '24px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      PAX (MTD)
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >
                      {this.state.bednightsMTD}
                    </div>
                  </GreenCard>
                </Col>
                <Col span={6}>
                  <GreenCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '24px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      Staff (MTD)
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >
                      {this.state.staffOnSiteMTD}
                    </div>
                  </GreenCard>
                </Col>
                <Col span={6}>
                  <RedCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '20px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      Complimentary / Refund
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >{`${companyCurrency} ${Math.abs(
                      this.state.refundsMTD || 0
                    ).toFixed(2)}`}</div>
                  </RedCard>
                </Col>
                <Col span={6}>
                  <BlueCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '24px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      Guide Meals
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >
                      {this.state.guideMealsMTD || 0}
                    </div>
                  </BlueCard>
                </Col>
                <Col span={6}>
                  <RedCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '24px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      Room Inclusion
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >{`${companyCurrency} ${(
                      this.state.compMTD || 0
                    ).toFixed(2)}`}</div>
                  </RedCard>
                </Col>
                {/* <Col span={12}>
                  <BlueCard>
                    <div style={{
                      marginTop: "0.2em",
                      fontSize: '24px',
                      fontWeight: 500,
                      fontFamily: "Nunito",
                    }}>Total Off Days</div>
                    <div style={{
                      marginTop: "-0.1em",
                      fontSize: '29px',
                      fontWeight: 800,
                      fontFamily: "Nunito",
                    }}>{this.state.totalOffDays || 0}</div>
                  </BlueCard>
                </Col> */}
                {/* <Col span={12}>
                  <TotalLeaveCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '24px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      Total Leave Days
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >
                      {this.state.totalLeaveDays || 0}
                    </div>
                  </TotalLeaveCard>
                </Col> */}
                <Col span={6}>
                  <LeaveBalanceCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '24px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      Leave Balance
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >
                      {this.state.totalLeaveBalance || 0}
                    </div>
                  </LeaveBalanceCard>
                </Col>
                <Col span={6}>
                  <ScoreCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '24px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      Score Achieved
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >
                      {this.state.groupedExperienceData?.[0]?.totalAvgScore !=
                      null
                        ? /* Already a percentage. */ `${Number(
                            this.state.groupedExperienceData[0].totalAvgScore
                          ).toFixed(1)}%`
                        : 'N/A'}
                    </div>
                  </ScoreCard>
                </Col>
                <Col span={6}>
                  <OrangeCard>
                    <div
                      style={{
                        marginTop: '0.2em',
                        fontSize: '24px',
                        fontWeight: 500,
                        fontFamily: 'Nunito'
                      }}
                    >
                      Low Score %
                    </div>
                    <div
                      style={{
                        marginTop: '-0.1em',
                        fontSize: '29px',
                        fontWeight: 800,
                        fontFamily: 'Nunito'
                      }}
                    >
                      {this.state.groupedExperienceData?.[0]
                        ?.lowScorePercentage !== undefined
                        ? `${
                            this.state.groupedExperienceData[0]
                              .lowScorePercentage
                          }%`
                        : 'N/A'}
                    </div>
                  </OrangeCard>
                </Col>
              </Row>
            </Col>
            <Col span={16} style={{ marginTop: '1em', marginBottom: '3em' }}>
              <Tabs defaultActiveKey="1" size="large" tabBarGutter={32}>
                <TabPane tab="Daily" key="1">
                  <AverageRoomRateChart
                    filteredStock={this.state.filteredStock}
                    filteredRooms={this.state.filteredRooms}
                    selectedYear={this.state.selectedYear}
                    selectedMonth={this.state.selectedMonth}
                  />
                </TabPane>

                <TabPane tab="Monthly" key="2">
                  <SingleMonthChart
                    stockData={this.state.stockData}
                    roomData={this.state.filteredRooms}
                    selectedYear={this.state.selectedYear}
                    selectedMonth={this.state.selectedMonth}
                  />
                </TabPane>
              </Tabs>
            </Col>
            <Col span={8} style={{ marginTop: '3.7em' }}>
              <CategoryStatusCard
                data={this.state.categoryStatusData}
                categories={Array.from(
                  new Set(
                    this.props.special.map(
                      i => i.actionDepartment || 'Uncategorized'
                    )
                  )
                )}
                selectedCategories={this.state.selectedCategories}
                onCategoryChange={cats =>
                  this.setState({ selectedCategories: cats }, this.filterData)
                }
              />
            </Col>
            <Col span={12}>
              <Cards
                title="Extra Sales"
                style={{
                  backgroundImage: `url(${CardBackImg})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  height: '450px'
                }}
              >
                <StyledTable
                  bordered={false}
                  dataSource={(this.state.filteredExtraSales || []).sort(
                    (a, b) => {
                      const categoryA = a.saleCategory || '';
                      const categoryB = b.saleCategory || '';
                      return categoryA.localeCompare(categoryB);
                    }
                  )}
                  pagination={false} // ✅ No slicing, show all rows
                  rowKey={record => record.saleCategory}
                  size="middle"
                  scroll={{ y: 260 }} // ✅ Enables vertical scrolling
                  summary={data => {
                    const totalIncome = data.reduce(
                      (sum, record) => sum + (record.totalIncome || 0),
                      0
                    );
                    const totalMTDSale = data.reduce(
                      (sum, record) => sum + (record.MTD_Sale || 0),
                      0
                    );

                    const companyCurrency =
                      this.props.sites.find(
                        site => site._id === this.state.siteSelected
                      )?.companyCurrency || 'Ksh';

                    return (
                      <StyledTable.Summary fixed="bottom">
                        {' '}
                        {/* ✅ Fixes the total row at the bottom */}
                        <StyledTable.Summary.Row>
                          <StyledTable.Summary.Cell index={0}>
                            <strong>Total</strong>
                          </StyledTable.Summary.Cell>
                          <StyledTable.Summary.Cell index={1}>
                            <strong>{`${companyCurrency} ${totalIncome.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            )}`}</strong>
                          </StyledTable.Summary.Cell>
                          <StyledTable.Summary.Cell index={2}>
                            <strong>{`${companyCurrency} ${totalMTDSale.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            )}`}</strong>
                          </StyledTable.Summary.Cell>
                        </StyledTable.Summary.Row>
                      </StyledTable.Summary>
                    );
                  }}
                >
                  {/* ✅ Category Column */}
                  <Column
                    title="Category"
                    dataIndex="saleCategory"
                    key="saleCategory"
                    sorter={(a, b) =>
                      a.saleCategory.localeCompare(b.saleCategory)
                    }
                    render={text => (text ? text : <div>Uncategorized</div>)}
                  />

                  {/* ✅ Total Income Column */}
                  <Column
                    title="Total Income"
                    key="totalIncome"
                    render={(text, record) => {
                      const companyCurrency =
                        this.props.sites.find(
                          site => site._id === this.state.siteSelected
                        )?.companyCurrency || 'Ksh';

                      return record.totalIncome != null
                        ? `${companyCurrency} ${record.totalIncome.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }
                          )}`
                        : '';
                    }}
                  />

                  {/* ✅ Month-to-Date (MTD) Per Bednight */}
                  <Column
                    title="MTD P/Bednight"
                    dataIndex="MTD_Sale"
                    key="MTD_Sale"
                    render={(text, record) => {
                      const companyCurrency =
                        this.props.sites.find(
                          site => site._id === this.state.siteSelected
                        )?.companyCurrency || 'Ksh';

                      return record.MTD_Sale != null
                        ? `${companyCurrency} ${record.MTD_Sale.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }
                          )}`
                        : `${companyCurrency} 0.00`;
                    }}
                  />
                </StyledTable>
              </Cards>
            </Col>
            <Col span={12}>
              <Cards
                title="Variable Cost"
                //   extra={
                //     <Select
                //       style={{ width: 220 }}
                //       placeholder="Select inventory site"
                //       value={this.state.inventorySiteSelected}
                //       onChange={this.handleInventorySiteChange}
                //       allowClear={false}
                //     >
                //       {(this.props.inventorySites || []).filter(
                //   s => s.siteType !== "supplierCheck"
                // ).map(s => (
                //         <Option key={s._id} value={s._id}>
                //           {s.name || s.siteName || "Site"}
                //         </Option>
                //       ))}
                //     </Select>
                //   }
                style={{
                  backgroundImage: `url(${CardBackImg})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  height: '450px'
                }}
              >
                <StyledTable
                  bordered={false}
                  dataSource={(this.state.filteredVarCost || []).sort(
                    (a, b) => {
                      const categoryA = a.costCategory || '';
                      const categoryB = b.costCategory || '';
                      return categoryA.localeCompare(categoryB);
                    }
                  )}
                  rowKey="costCategory"
                  pagination={false}
                  size="middle"
                  scroll={{ y: 260 }} // ✅ Enables vertical scrolling
                  summary={data => {
                    const selectedSite = this.getSiteById(
                      this.props.sites,
                      this.state.siteSelected
                    );

                    // the site that actually produced the costs (inventory mapped site if present, else selected site)
                    const sourceSite =
                      this.getSiteById(
                        this.props.inventorySites,
                        this.state.inventoryCostSiteId
                      ) || selectedSite;

                    const totalCostRaw = data.reduce(
                      (sum, r) => sum + (r.totalCost || 0),
                      0
                    );
                    const totalMTDRaw = data.reduce(
                      (sum, r) => sum + (r.MTD_Cost || 0),
                      0
                    );

                    const totalCostConv = this.convertToTargetCurrency(
                      totalCostRaw,
                      sourceSite,
                      selectedSite
                    );
                    const totalMTDConv = this.convertToTargetCurrency(
                      totalMTDRaw,
                      sourceSite,
                      selectedSite
                    );
                    const totalCost = data.reduce(
                      (sum, record) => sum + (record.totalCost || 0),
                      0
                    );
                    const totalMTDCost = data.reduce(
                      (sum, record) => sum + (record.MTD_Cost || 0),
                      0
                    );

                    const companyCurrency =
                      this.props.sites.find(
                        site => site._id === this.state.siteSelected
                      )?.companyCurrency || 'Ksh';

                    return (
                      <StyledTable.Summary fixed="bottom">
                        {' '}
                        {/* ✅ Fixes the total row at the bottom */}
                        <StyledTable.Summary.Row>
                          <StyledTable.Summary.Cell index={0}>
                            <strong>Total</strong>
                          </StyledTable.Summary.Cell>
                          <StyledTable.Summary.Cell index={1}>
                            <strong>
                              {this.formatMoney(
                                totalCostConv.currency,
                                totalCostConv.value
                              )}
                            </strong>
                          </StyledTable.Summary.Cell>
                          <StyledTable.Summary.Cell index={2}>
                            <strong>
                              {this.formatMoney(
                                totalMTDConv.currency,
                                totalMTDConv.value
                              )}
                            </strong>
                          </StyledTable.Summary.Cell>
                        </StyledTable.Summary.Row>
                      </StyledTable.Summary>
                    );
                  }}
                >
                  {/* ✅ Category Column */}
                  <Column
                    title="Category"
                    dataIndex="costCategory"
                    key="costCategory"
                    sorter={(a, b) =>
                      a.costCategory.localeCompare(b.costCategory)
                    }
                  />

                  {/* ✅ Total Cost Column */}
                  <Column
                    title="Total Cost"
                    dataIndex="totalCost"
                    key="totalCost"
                    render={(text, record) => {
                      const selectedSite = this.getSiteById(
                        this.props.sites,
                        this.state.siteSelected
                      );
                      const sourceSite =
                        this.getSiteById(
                          this.props.inventorySites,
                          this.state.inventoryCostSiteId
                        ) || selectedSite;

                      const conv = this.convertToTargetCurrency(
                        record.totalCost || 0,
                        sourceSite,
                        selectedSite
                      );
                      return this.formatMoney(conv.currency, conv.value);
                    }}
                  />

                  {/* ✅ MTD Per Bednight / Per Staff Column */}
                  <Column
                    title={
                      this.state.inventoryCostSiteId
                        ? 'MTD P/Bednight'
                        : 'MTD P/Bednight'
                    }
                    dataIndex="MTD_Cost"
                    key="MTD_Cost"
                    render={(text, record) => {
                      const selectedSite = this.getSiteById(
                        this.props.sites,
                        this.state.siteSelected
                      );
                      const sourceSite =
                        this.getSiteById(
                          this.props.inventorySites,
                          this.state.inventoryCostSiteId
                        ) || selectedSite;

                      const conv = this.convertToTargetCurrency(
                        record.MTD_Cost || 0,
                        sourceSite,
                        selectedSite
                      );
                      const label =
                        this.state.inventoryCostSiteId &&
                        record.costCategory === 'Staff Canteen Cost'
                          ? ' P/Staff'
                          : ' ';
                      return `${this.formatMoney(
                        conv.currency,
                        conv.value
                      )}${label}`;
                    }}
                  />
                </StyledTable>
              </Cards>
            </Col>
          </Row>
          <Row gutter={24} style={{ marginTop: '2.5em' }}>
            {/* Experience Chart on the Left */}
            <Col span={14} style={{ marginBottom: '2em' }}>
              <ExperienceBarChart
                groupedExperienceData={this.state.groupedExperienceData}
              />
            </Col>

            {/* Complimentary breakdown alongside the experience chart */}
            <Col span={10} style={{ marginBottom: '2em' }}>
              <Cards
                title="Room Inclusion"
                style={{
                  backgroundImage: `url(${CardBackImg})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  height: '450px'
                }}
              >
                <StyledTable
                  bordered={false}
                  dataSource={(this.state.groupedComp || [])
                    .slice()
                    .sort((a, b) =>
                      (a.compCategory || '').localeCompare(b.compCategory || '')
                    )}
                  rowKey="compCategory"
                  pagination={false}
                  size="middle"
                  scroll={{ y: 260 }}
                  summary={data => {
                    const companyCurrency =
                      this.props.sites.find(
                        site => site._id === this.state.siteSelected
                      )?.companyCurrency || 'Ksh';

                    const totalItems = data.reduce(
                      (sum, r) => sum + (r.count || 0),
                      0
                    );
                    const totalValue = data.reduce(
                      (sum, r) => sum + (r.totalComp || 0),
                      0
                    );
                    const totalPerBednight = data.reduce(
                      (sum, r) => sum + (r.MTD_Comp || 0),
                      0
                    );

                    return (
                      <StyledTable.Summary fixed="bottom">
                        <StyledTable.Summary.Row>
                          <StyledTable.Summary.Cell index={0}>
                            <strong>Total</strong>
                          </StyledTable.Summary.Cell>
                          <StyledTable.Summary.Cell index={1}>
                            <strong>{totalItems}</strong>
                          </StyledTable.Summary.Cell>
                          <StyledTable.Summary.Cell index={2}>
                            <strong>
                              {this.formatMoney(companyCurrency, totalValue)}
                            </strong>
                          </StyledTable.Summary.Cell>
                          <StyledTable.Summary.Cell index={3}>
                            <strong>
                              {this.formatMoney(
                                companyCurrency,
                                totalPerBednight
                              )}
                            </strong>
                          </StyledTable.Summary.Cell>
                        </StyledTable.Summary.Row>
                      </StyledTable.Summary>
                    );
                  }}
                >
                  <Column
                    title="Category"
                    dataIndex="compCategory"
                    key="compCategory"
                    sorter={(a, b) =>
                      (a.compCategory || '').localeCompare(b.compCategory || '')
                    }
                  />
                  <Column
                    title="Items"
                    dataIndex="count"
                    key="count"
                    sorter={(a, b) => (a.count || 0) - (b.count || 0)}
                  />
                  <Column
                    title="Total Value"
                    dataIndex="totalComp"
                    key="totalComp"
                    sorter={(a, b) => (a.totalComp || 0) - (b.totalComp || 0)}
                    render={(text, record) => {
                      const companyCurrency =
                        this.props.sites.find(
                          site => site._id === this.state.siteSelected
                        )?.companyCurrency || 'Ksh';
                      return this.formatMoney(
                        companyCurrency,
                        record.totalComp || 0
                      );
                    }}
                  />
                  <Column
                    title="MTD P/Bednight"
                    dataIndex="MTD_Comp"
                    key="MTD_Comp"
                    render={(text, record) => {
                      const companyCurrency =
                        this.props.sites.find(
                          site => site._id === this.state.siteSelected
                        )?.companyCurrency || 'Ksh';
                      return this.formatMoney(
                        companyCurrency,
                        record.MTD_Comp || 0
                      );
                    }}
                  />
                </StyledTable>
              </Cards>
            </Col>
          </Row>

        </Spin>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    collapsed: getSidebarCollapsed(state)
  };
};
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tailoring);
